// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gMAXt","card":"styles_card__ulEm8"};